/** Shared change-request type pill styles (listing + overview tabs). */
export const getTypeStyle = (type) => {
  if (type === "STANDARD") return { text: "BOQ/ Payments", color: "#d46b08", backgroundColor: "#fff7e6" };
  if (type === "TIMELINE") return { text: "Timeline Extensions", color: "#096dd9", backgroundColor: "#e6f7ff" };
  if (type === "DESIGN") return { text: "Design Update", color: "#c41d7f", backgroundColor: "#fff0f6" };
  return { text: type, color: "#0D0D0E", backgroundColor: "#f0f0f0" };
};

/** MUI `sx` for change-type pill to match ChangeRequestList */
export const changeTypePillSx = (type) => {
  const s = getTypeStyle(type);
  return {
    display: "inline-block",
    fontSize: "14px",
    fontWeight: 600,
    px: "8px",
    py: "4px",
    borderRadius: "34px",
    color: s.color,
    backgroundColor: s.backgroundColor,
    border: "none",
    lineHeight: 1.4,
  };
};
